const wxAppRoutes = [
  {
    path: '/logistics/view',
    name: 'logistics-view',
    component: () => import('@/views/wx-app/logistics-view.vue')
  },
  {
    path: '/cass-login/2022',
    name: 'cass-login-2022',
    component: () => import('@/views/wx-app/cass-login-2022.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/wx-app/privacy.vue')
  },
  {
    path: '/privacy-msg',
    name: 'privacy-msg',
    component: () => import('@/views/wx-app/privacy-msg.vue')
  },
  {
    path: '/order-link',
    name: 'order-link',
    component: () => import('@/views/wx-app/order-link.vue')
  }
]

export default wxAppRoutes
